import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSkillshareComponent } from './simple-icons-skillshare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSkillshareComponent ],
    exports:      [ SimpleIconsSkillshareComponent ],
    bootstrap:    []
})
export class SimpleIconsSkillshareModule {}
